<span class="icc-button-wrapper">
    <span class="content">
        <span
            *ngIf="prefixIcon"
            class="icc-button-prefix-icon"
        >
            <icc-icon [name]="prefixIcon"></icc-icon>
        </span>
        <ng-content></ng-content>
    </span>
</span>
<span class="icc-button-focus-overlay"></span>